export default __webpack_public_path__ + "static/media/title-image.c6adb90d.png";